import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import { dateOptionsCriteria, footfallTabCriteria, boundariesCriteria } from '../../../utilities/epic-helpers';

import {
  FETCH_INSIGHTS_FOOTFALL,
  FETCH_INSIGHTS_FOOTFALL_ERROR,
  SET_INSIGHTS_FOOTFALL,
} from '../../constants';


const insightsFootfall = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_INSIGHTS_FOOTFALL),
    switchMap(() =>
      ajax({
        url: `${
          state$.value.auth.server
        }/report/organisations?${
          footfallTabCriteria(state$)
        }${
          boundariesCriteria(state$)
        }${
          dateOptionsCriteria(state$, 'footfall')
        }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SET_INSIGHTS_FOOTFALL,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_INSIGHTS_FOOTFALL_ERROR,
            error,
          })
        )
      )
    )
  );

export default insightsFootfall;
